import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
} from '@epicuro-next/platform/environment';

/**
 * `canMatch` guard that allows the RUM validation route only in lower
 * environments. In production (`env === 'prod'`) the route does not match, so it
 * falls through to the wildcard redirect and the panel is unreachable.
 */
export const rumValidationEnabledGuard: CanMatchFn = () => {
  const settings = inject<EnvironmentSettings>(ENVIRONMENT_SETTINGS);
  return settings?.env !== 'prod';
};
